import MoreHoriz from "@mui/icons-material/MoreHoriz";
import {
  CircularProgress,
  IconButton,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography,
} from "@mui/material";
import { alpha } from "@mui/material/styles";

export type TrayFilter = "unread" | "all";

export function NotificationTrayHeader({
  filter,
  onFilterChange,
  refreshing,
  onActionsClick,
}: {
  filter: TrayFilter;
  onFilterChange: (filter: TrayFilter) => void;
  refreshing: boolean;
  onActionsClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}) {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      sx={{ pl: 2, pr: 1, py: 1.25 }}
    >
      <Stack direction="row" alignItems="center" spacing={1.25}>
        <Typography variant="subtitle1" fontWeight={700}>
          Notifications
        </Typography>
        <ToggleButtonGroup
          value={filter}
          exclusive
          size="small"
          onChange={(_event, value: TrayFilter | null) => {
            if (value !== null) onFilterChange(value);
          }}
          aria-label="Filter notifications"
          sx={{
            "& .MuiToggleButton-root": {
              border: 0,
              borderRadius: 999,
              px: 1.25,
              py: 0.25,
              fontSize: 11,
              fontWeight: 600,
              letterSpacing: 0.3,
              lineHeight: 1.2,
              textTransform: "uppercase",
              color: "text.secondary",
            },
            "& .MuiToggleButton-root.Mui-selected": {
              bgcolor: (theme) => alpha(theme.palette.primary.main, 0.12),
              color: "primary.main",
            },
          }}
        >
          <ToggleButton value="all">All</ToggleButton>
          <ToggleButton value="unread">Unread</ToggleButton>
        </ToggleButtonGroup>
        {refreshing ? (
          <CircularProgress
            aria-label="Refreshing notifications"
            data-testid="notifications-tray-title-loading"
            size={13}
            thickness={5}
            sx={{ color: "text.disabled" }}
          />
        ) : null}
      </Stack>
      <Tooltip title="Notification actions">
        <IconButton
          aria-label="Notification actions"
          size="small"
          onClick={onActionsClick}
          sx={{
            color: "text.secondary",
            height: 32,
            width: 32,
          }}
        >
          <MoreHoriz />
        </IconButton>
      </Tooltip>
    </Stack>
  );
}
